/**
 * @description 活动模块
 */
export default [

]